import { createReducer } from 'redux-create-reducer'
import {
  SEATS_AND_TRACKS_UPDATE,
  SEATS_AND_TRACKS_UPDATE_SUCCESS,
} from '@disco/constants/ActionTypes'
const initialState = {
  items: {},
}
export type State = {
  items: Record<string, boolean>
}
export const seatsAndTracksReducer = createReducer<State, any>(initialState, {
  [SEATS_AND_TRACKS_UPDATE](state, action) {
    const updateItems = {}
    action.items.forEach(({ type }) => (updateItems[type] = true))
    return {
      items: { ...state.items, ...updateItems },
    }
  },

  [SEATS_AND_TRACKS_UPDATE_SUCCESS](state, action) {
    const updateItems = {}
    action.items.forEach(({ type }) => (updateItems[type] = false))
    return {
      items: { ...state.items, ...updateItems },
    }
  },
})
